module.exports = "https://coursera_assets.s3.amazonaws.com/images/9146da888f067f43dde3b92a89d53cd5.svg";